// v3-patch-route-and-intercept-fetch
(function () {
  // Shopify's predictive search by default only searches:
  //   title, product_type, variants.title, vendor
  // Books and magazines that have "travel" or other category words in tags or
  // description won't match. This patches the route URL so the bundle's fetch
  // always includes the extra fields param.
  var EXTRA = 'resources%5Boptions%5D%5Bfields%5D=title%2Cproduct_type%2Cvariants.title%2Cvendor%2Ctag%2Cbody';

  function patchRoute() {
    try {
      if (!window.theme || !window.theme.routes || !window.theme.routes.predictive_search_url) return false;
      var url = window.theme.routes.predictive_search_url;
      if (url.indexOf('resources%5Boptions%5D%5Bfields%5D') !== -1) return true;
      var sep = url.indexOf('?') === -1 ? '?' : '&';
      window.theme.routes.predictive_search_url = url + sep + EXTRA;
      return true;
    } catch (e) { return false; }
  }

  // Belt and braces: also wrap fetch so any direct /search/suggest call gets the fields too.
  if (window.fetch && !window.__acPredictiveFetchWrapped) {
    window.__acPredictiveFetchWrapped = true;
    var origFetch = window.fetch;
    window.fetch = function (input, init) {
      try {
        var url = typeof input === 'string' ? input : (input && input.url);
        if (url && url.indexOf('/search/suggest') !== -1 && url.indexOf('resources%5Boptions%5D%5Bfields%5D') === -1) {
          var sep = url.indexOf('?') === -1 ? '?' : '&';
          var newUrl = url + sep + EXTRA;
          if (typeof input === 'string') input = newUrl;
          else if (input && input.url) input = new Request(newUrl, input);
        }
      } catch (e) {}
      return origFetch.call(this, input, init);
    };
  }

  // Patch the route now if theme is ready; otherwise poll briefly.
  if (!patchRoute()) {
    var tries = 0;
    var t = setInterval(function () {
      tries++;
      if (patchRoute() || tries > 100) clearInterval(t);
    }, 20);
  }
})();
